module.exports = __webpack_public_path__ + "static/media/kuaraLogoBGDown.50067ab0.svg";